import { useEffect, useMemo } from "react";
import { useWebsite } from "../../../context/WebsiteContext";
import { useWeb } from "../../../context/WebContext";
import { WebInput, WebButton } from "./shared";

export default function SearchResults() {
  const { currentURL, navigateToURL, setPageTitle, setPageIcon } = useWebsite();
  const { search, results, loading } = useWeb();

  const searchQuery = useMemo(() => {
    try {
      const url = new URL(currentURL);
      return url.searchParams.get("q") || "";
    } catch {
      return "";
    }
  }, [currentURL]);

  // perform search when query changes
  useEffect(() => {
    search(searchQuery);
  }, [searchQuery, search]);

  useEffect(() => {
    setPageTitle(`Search Results for "${searchQuery}"`);
    setPageIcon(undefined);
  }, [searchQuery, setPageTitle, setPageIcon]);

  return (
    <div
      style={{
        display: "flex",
        flexGrow: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: "12px",
        padding: "16px",
        backgroundImage: "url(./backgrounds/clouds.gif)",
        backgroundRepeat: "repeat",
        backgroundAttachment: "scroll",
        width: "100%",
      }}
    >
      <div style={{ width: "100%" }}>
        <h2 style={{ margin: "0 0 8px 0" }}>Search Results</h2>
        <p style={{ margin: "0 0 12px 0", fontSize: "13px", color: "#666" }}>
          {loading
            ? "Searching..."
            : `${results.length} result${results.length !== 1 ? "s" : ""} found for "${searchQuery}"`}
        </p>
      </div>

      <div style={{ width: "100%", display: "flex", gap: "8px" }}>
        <WebInput
          placeholder="Search again..."
          value={searchQuery}
          onChange={(e) => {
            navigateToURL(`http://home.dom?q=${encodeURIComponent(e.target.value)}`);
          }}
          style={{ flex: 1 }}
        />
        <WebButton
          label="Search"
          onClick={() => {
            navigateToURL(`http://home.dom?q=${encodeURIComponent(searchQuery)}`);
          }}
        />
      </div>

      <div style={{ width: "100%" }}>
        {loading ? (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
            }}
          >
            Loading results...
          </div>
        ) : results.length > 0 ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {results.map((result, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "rgba(246, 234, 234, 0.6)",
                  padding: "8px",
                  borderRadius: "2px",
                  cursor: "pointer",
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.backgroundColor =
                    "rgba(246, 234, 234, 0.9)";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.backgroundColor =
                    "rgba(246, 234, 234, 0.6)";
                }}
                onClick={() => navigateToURL(result.url)}
              >
                <div
                  style={{
                    color: "blue",
                    textDecoration: "underline",
                    fontWeight: "bold",
                    fontSize: "14px",
                    marginBottom: "4px",
                  }}
                >
                  {result.title}
                </div>
                <div style={{ fontSize: "12px", color: "#666", marginBottom: "4px" }}>
                  {result.url}
                </div>
                <div style={{ fontSize: "13px", color: "#333" }}>{result.description}</div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              padding: "24px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
            }}
          >
            No results found. Try a different search query!
          </div>
        )}
      </div>
    </div>
  );
}
